import HeaderCopy from "./HeaderCopy";
import NavBar from "./NavBar";

const Header = () => {
    return ( 
        <header>
            <NavBar/>
            <HeaderCopy/>
        </header>
     );
}
 
export default Header;